export interface Product {
  id: string;
  name: string;
  category: string;
  price: number;
  description: string;
  material: string;
  craft: string;
  size: string;
  image: string;
  tags: string[];
  featured: boolean;
  date: string;
}

export const products: Product[] = [
  {
    id: 'p001',
    name: '紫檀木雕·如意观音',
    category: 'gongyi-baijian',
    price: 8800,
    description: '选用上等小叶紫檀整料雕刻，观音面相慈悲安详，衣纹流畅自然。全手工精雕细琢，历时三月方成，木质细腻油润，手感极佳。',
    material: '小叶紫檀',
    craft: '手工雕刻',
    size: '高32cm × 宽12cm',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20small%20leaf%20red%20sandalwood%20carving%20of%20Guanyin%20bodhisattva%20statue%2C%20intricate%20handcrafted%20details%2C%20warm%20wood%20texture%2C%20cream%20background%2C%20museum%20quality%20product%20photography%2C%20soft%20dramatic%20lighting&width=800&height=800&seq=prod-001&orientation=squarish',
    tags: ['木雕', '观音', '紫檀', '手工'],
    featured: true,
    date: '2026-06-15',
  },
  {
    id: 'p002',
    name: '宜兴紫砂·石瓢壶',
    category: 'chaye-chaju',
    price: 5600,
    description: '宜兴黄龙山原矿紫泥手工制作，造型端庄稳重，出水流畅有力。壶身线条刚柔并济，壶钮桥形设计便于拿捏，是茶道爱好者不可多得的佳品。',
    material: '黄龙山原矿紫泥',
    craft: '全手工制壶',
    size: '容量280ml',
    image: 'https://readdy.ai/api/search-image?query=Yixing%20purple%20clay%20shipiao%20teapot%20with%20traditional%20design%2C%20handcrafted%20by%20master%20artisan%2C%20elegant%20minimalist%20composition%2C%20cream%20background%2C%20warm%20natural%20lighting%2C%20product%20photography&width=800&height=800&seq=prod-002&orientation=squarish',
    tags: ['紫砂', '茶壶', '手工', '宜兴'],
    featured: true,
    date: '2026-07-02',
  },
  {
    id: 'p003',
    name: '和田玉·平安无事牌',
    category: 'shoucang-jingpin',
    price: 28600,
    description: '新疆和田籽料，玉质温润细腻，白度上佳，结构紧密。无事牌寓意平安无事、吉祥如意，牌面光素无饰，尽显玉质之美。',
    material: '和田籽料',
    craft: '手工打磨',
    size: '长5.8cm × 宽3.6cm × 厚0.9cm',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20white%20Hetian%20jade%20peace%20plaque%20with%20smooth%20surface%2C%20natural%20jade%20texture%20visible%2C%20cream%20background%2C%20museum%20quality%20product%20photography%2C%20soft%20dramatic%20lighting%20highlighting%20translucency&width=800&height=800&seq=prod-003&orientation=squarish',
    tags: ['和田玉', '无事牌', '收藏', '籽料'],
    featured: true,
    date: '2026-05-20',
  },
  {
    id: 'p004',
    name: '太行崖柏·随形手把件',
    category: 'wenwan-bajian',
    price: 1280,
    description: '太行山陈化崖柏老料，纹理如行云流水，香气醇厚持久。随形设计保留木料天然形态，手感贴合掌心，盘玩之间愈发油亮。',
    material: '太行崖柏',
    craft: '手工打磨',
    size: '约6cm × 4cm × 3cm',
    image: 'https://readdy.ai/api/search-image?query=Natural%20arborvitae%20wood%20hand%20piece%20with%20beautiful%20grain%20patterns%2C%20smooth%20polished%20surface%2C%20organic%20shape%2C%20cream%20background%2C%20warm%20lighting%2C%20product%20photography%20highlighting%20wood%20texture&width=800&height=800&seq=prod-004&orientation=squarish',
    tags: ['崖柏', '把件', '文玩', '太行'],
    featured: false,
    date: '2026-06-28',
  },
  {
    id: 'p005',
    name: '端砚·云龙纹',
    category: 'wenfang-sibao',
    price: 6800,
    description: '广东肇庆端溪老坑石，石质细腻温润，呵气可研。砚面浮雕云龙纹，雕工精湛，龙首高昂，云雾缭绕，文房雅器之上品。',
    material: '端溪老坑石',
    craft: '手工雕刻',
    size: '长22cm × 宽14cm × 厚3cm',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20Duan%20inkstone%20with%20cloud%20dragon%20relief%20carving%2C%20dark%20stone%20with%20subtle%20texture%2C%20cream%20background%2C%20museum%20quality%20product%20photography%2C%20elegant%20scholar%20aesthetic&width=800&height=800&seq=prod-005&orientation=squarish',
    tags: ['端砚', '文房', '雕刻', '云龙'],
    featured: true,
    date: '2026-04-18',
  },
  {
    id: 'p006',
    name: '景德镇·青花缠枝莲盖碗',
    category: 'chaye-chaju',
    price: 1680,
    description: '景德镇高白泥手工拉坯，釉面莹润如玉。青花发色纯正，缠枝莲花纹样繁而不乱，盖碗三件套完整，泡茶赏器两相宜。',
    material: '高白泥',
    craft: '手工拉坯+手绘青花',
    size: '容量150ml',
    image: 'https://readdy.ai/api/search-image?query=Jingdezhen%20blue%20and%20white%20porcelain%20gaiwan%20with%20lotus%20scroll%20pattern%2C%20handpainted%20traditional%20Chinese%20design%2C%20cream%20background%2C%20elegant%20product%20photography%2C%20soft%20lighting&width=800&height=800&seq=prod-006&orientation=squarish',
    tags: ['青花', '盖碗', '景德镇', '手工'],
    featured: false,
    date: '2026-07-10',
  },
  {
    id: 'p007',
    name: '黄杨木雕·竹林七贤笔筒',
    category: 'wenfang-sibao',
    price: 4200,
    description: '选用百年黄杨老料，木质坚韧细腻。筒身通景雕刻竹林七贤图，人物神态各异，栩栩如生，竹林层次分明，意境深远。',
    material: '黄杨木',
    craft: '手工通景雕刻',
    size: '高18cm × 口径10cm',
    image: 'https://readdy.ai/api/search-image?query=Boxwood%20carved%20brush%20holder%20with%20seven%20sages%20of%20bamboo%20grove%20scene%2C%20intricate%20relief%20carving%20details%2C%20warm%20wood%20tone%2C%20cream%20background%2C%20museum%20quality%20product%20photography&width=800&height=800&seq=prod-007&orientation=squarish',
    tags: ['黄杨木', '笔筒', '雕刻', '文房'],
    featured: true,
    date: '2026-05-08',
  },
  {
    id: 'p008',
    name: '蜜蜡·金绞蜜手把件',
    category: 'wenwan-bajian',
    price: 3800,
    description: '天然波罗的海蜜蜡，金绞蜜质地通透温润，内部纹理如云雾飘渺，色泽金黄迷人。手工打磨圆润光滑，盘玩手感极佳。',
    material: '天然蜜蜡',
    craft: '手工打磨',
    size: '约5cm × 3.5cm × 2cm',
    image: 'https://readdy.ai/api/search-image?query=Natural%20Baltic%20amber%20honey%20wax%20hand%20piece%20with%20golden%20translucent%20texture%2C%20smooth%20polished%20surface%2C%20warm%20glowing%20appearance%2C%20cream%20background%2C%20luxury%20product%20photography&width=800&height=800&seq=prod-008&orientation=squarish',
    tags: ['蜜蜡', '把件', '文玩', '天然'],
    featured: false,
    date: '2026-06-22',
  },
  {
    id: 'p009',
    name: '龙泉青瓷·梅子青斗笠盏',
    category: 'chaye-chaju',
    price: 960,
    description: '龙泉窑传统工艺烧制，釉色如青梅般青翠欲滴，釉层厚润如玉。斗笠造型简洁大方，口沿微撇，持握舒适，是品茗赏瓷的上选。',
    material: '龙泉瓷土',
    craft: '手工拉坯+青釉烧制',
    size: '口径8cm × 高5cm',
    image: 'https://readdy.ai/api/search-image?query=Longquan%20celadon%20tea%20cup%20with%20plum%20green%20glaze%2C%20traditional%20Chinese%20ceramic%20craftsmanship%2C%20elegant%20simple%20form%2C%20cream%20background%2C%20soft%20natural%20lighting%2C%20product%20photography&width=800&height=800&seq=prod-009&orientation=squarish',
    tags: ['龙泉青瓷', '茶杯', '手工', '斗笠'],
    featured: false,
    date: '2026-07-15',
  },
  {
    id: 'p010',
    name: '翡翠·冰种福豆挂件',
    category: 'shoucang-jingpin',
    price: 35800,
    description: '缅甸天然翡翠冰种料，质地冰透莹润，光泽柔和。雕刻福豆造型饱满圆润，寓意多子多福、四季平安。配18K金扣头。',
    material: '缅甸翡翠冰种',
    craft: '手工雕刻',
    size: '长4.2cm × 宽1.6cm × 厚0.8cm',
    image: 'https://readdy.ai/api/search-image?query=Icy%20translucent%20jadeite%20pendant%20carved%20as%20lucky%20bean%2C%20smooth%20glossy%20surface%2C%20elegant%20green%20hue%2C%20cream%20background%2C%20luxury%20jewelry%20photography%2C%20soft%20dramatic%20lighting&width=800&height=800&seq=prod-010&orientation=squarish',
    tags: ['翡翠', '挂件', '冰种', '收藏'],
    featured: true,
    date: '2026-04-25',
  },
  {
    id: 'p011',
    name: '黑檀木·百宝嵌首饰盒',
    category: 'liwu-jingxuan',
    price: 2600,
    description: '黑檀木为胎，螺钿、寿山石、象牙等多种材料镶嵌出花鸟图案。内置多层分隔，兼具实用与观赏价值，送礼自用皆宜。',
    material: '黑檀木+螺钿+寿山石',
    craft: '百宝嵌工艺',
    size: '长20cm × 宽14cm × 高10cm',
    image: 'https://readdy.ai/api/search-image?query=Ebony%20wood%20jewelry%20box%20with%20mother%20of%20pearl%20inlay%20floral%20design%2C%20traditional%20Chinese%20craftsmanship%2C%20elegant%20dark%20wood%20with%20colorful%20inlays%2C%20cream%20background%2C%20luxury%20product%20photography&width=800&height=800&seq=prod-011&orientation=squarish',
    tags: ['黑檀', '首饰盒', '百宝嵌', '礼品'],
    featured: false,
    date: '2026-06-10',
  },
  {
    id: 'p012',
    name: '鸡翅木·如意博古架',
    category: 'gongyi-baijian',
    price: 4800,
    description: '精选非洲鸡翅木，木纹如鸡翅羽毛般美丽独特。博古架造型古朴典雅，多层错落设计，既可陈设藏品，本身亦为一件精美家具。',
    material: '非洲鸡翅木',
    craft: '传统榫卯工艺',
    size: '高80cm × 宽60cm × 深25cm',
    image: 'https://readdy.ai/api/search-image?query=Wenge%20wood%20display%20shelf%20with%20traditional%20Chinese%20mortise%20and%20tenon%20joinery%2C%20elegant%20dark%20wood%20grain%2C%20minimalist%20design%2C%20cream%20background%2C%20furniture%20product%20photography&width=800&height=800&seq=prod-012&orientation=squarish',
    tags: ['鸡翅木', '博古架', '家具', '榫卯'],
    featured: true,
    date: '2026-05-30',
  },
];

export const getProductsByCategory = (categorySlug: string): Product[] => {
  return products.filter((p) => p.category === categorySlug);
};

export const getFeaturedProducts = (): Product[] => {
  return products.filter((p) => p.featured);
};

export const getProductById = (id: string): Product | null => {
  return products.find((p) => p.id === id) || null;
};